import API from "../../common/utils/API";
import { apiActionsKYBTestcache } from "../../support/actions/SupportActionConstants";
import { activityLoggerActionTypes } from "../veritas-middleware/constants/UtilityMiddlewareConstants";
import { toUpperCaseSentence } from "../../common/utils/ToUpperCaseSentence";
import { displayErrorMessage } from "../../common/marvel-reducers/formMessageActions";
import {
    fetchKYBTestcacheTableData, loadSourcesForKYBTestcache,
    kybTestcacheTableDataSuccess, toggleAddKYBTestcacheRecordsModal,
    toggleDeleteKYBTestcacheRecordsModal,
    toggleEditKYBTestcacheRecordsModal, updateKYBTestcacheFilters
} from "../../support/actions/KYBTestCacheActions";
import * as Validation from "../../common/utils/Validation";

/**
 * This is the Middleware to handle the KYB testcache operations from Marvel.
 * @param store, action
 * @returns Makes the List and CRUD API calls for KYB testcache app in Marvel.
 */
const KYBTestCacheMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsKYBTestcache.GET_ALL_KYB_TESTCACHE: {
            next(action);

            const { authToken } = action.payload;

            API.getKYBTestcacheAll(authToken.idToken)
                .then(res => {
                    store.dispatch(kybTestcacheTableDataSuccess(res.data.testcache_obj))
                    store.dispatch(updateKYBTestcacheFilters());
                    store.dispatch(loadSourcesForKYBTestcache(res.data.source_types_list))
                }).catch(error => {
                    console.error(error)
                });

            break;
        }

        case apiActionsKYBTestcache.ADD_TO_KYB_TESTCACHE: {
            next(action);

            const { authToken, kybTestcacheObject } = action.payload;
            // validate inputs
            const validationResult = Validation.validateKYBTestcacheForm(kybTestcacheObject);
            if (validationResult && validationResult.isValid) {
                API.postKYBTestcacheRecord(authToken.idToken, kybTestcacheObject)
                    .then(res => {
                        const log = {
                            object_id: res.data.id,
                            object_type: "kyb_testcache_create",
                            user: authToken.account.name
                        };
                        store.dispatch({
                            type: activityLoggerActionTypes.LOG_CHANGE,
                            payload: { log, authToken }
                        });
                        store.dispatch(toggleAddKYBTestcacheRecordsModal());
                        store.dispatch(fetchKYBTestcacheTableData());
                    }).catch(error => {
                        const errorObject = error.response?.data || { error: 'An error occurred' };
                        const message = [];
                        // pretty print the error message for the user
                        for (let [key, value] of Object.entries(errorObject)) {
                            const errorMessage = key + ": " + toUpperCaseSentence(value)
                            message.push(errorMessage);
                        }
                        store.dispatch(displayErrorMessage(message, true));
                    });
            }

            break;
        }

        case apiActionsKYBTestcache.EDIT_KYB_TESTCACHE: {
            next(action);

            const { authToken, kybTestcacheObject, kybTestcacheId } = action.payload;
            // validate inputs
            const validationResult = Validation.validateKYBTestcacheForm(kybTestcacheObject);
            if (validationResult && validationResult.isValid) {
                API.putKYBTestcacheRecord(authToken.idToken, kybTestcacheObject, kybTestcacheId)
                    .then(res => {
                        const log = {
                            object_id: res.data.id,
                            object_type: "kyb_testcache_edit",
                            user: authToken.account.name
                        };
                        store.dispatch({
                            type: activityLoggerActionTypes.LOG_CHANGE,
                            payload: { log, authToken }
                        });
                        store.dispatch(toggleEditKYBTestcacheRecordsModal());
                        store.dispatch(fetchKYBTestcacheTableData());
                    }).catch(error => {
                        const errorObject = error.response?.data || { error: 'An error occurred' };
                        const message = [];
                        // pretty print the error message for the user
                        // eslint-disable-next-line no-unused-vars
                        for (let [key, value] of Object.entries(errorObject)) {
                            message.push(toUpperCaseSentence(Array.isArray(value) ? value[0] : value));
                        }
                        store.dispatch(displayErrorMessage(message, true));
                    });
            }

            break;
        }

        case apiActionsKYBTestcache.DELETE_KYB_TESTCACHE: {
            next(action);

            const { authToken, kybTestcacheId } = action.payload;
            API.deleteKYBTestcacheRecord(authToken.idToken, kybTestcacheId)
                .then(() => {
                    const log = {
                        object_id: kybTestcacheId,
                        object_type: "kyb_testcache_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(toggleDeleteKYBTestcacheRecordsModal());
                    store.dispatch(fetchKYBTestcacheTableData());
                }).catch(error => {
                    const errorObject = error.response?.data || { error: 'An error occurred' };
                    const message = [];
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        message.push(toUpperCaseSentence(Array.isArray(value) ? value[0] : value));
                    }
                    store.dispatch(displayErrorMessage(message, true));
                });

            break;
        }

        default: next(action)
    }
}


export default KYBTestCacheMiddleware;

